export default "/weETH.fe97d32259fba414c9e65893ff86cac5.svg";